import api from '../../lib/api';
import type { PlatformAccessLevel } from './platformAccessLevel';

export interface PermissionDefinition {
  key: string;
  label: string;
  description: string;
  standards?: import('../../constants/isoStandards').IsoStandard[];
}

export async function fetchEffectivePermissions(): Promise<Record<string, PlatformAccessLevel>> {
  const { data } = await api.get<{ success: boolean; data: Record<string, PlatformAccessLevel> }>(
    'platform-permissions/effective/me'
  );
  return data.data;
}

let registryCache: PermissionDefinition[] | null = null;

export function clearPermissionRegistryCache(): void {
  registryCache = null;
}

export async function fetchPermissionRegistry(): Promise<PermissionDefinition[]> {
  if (registryCache) {
    return registryCache;
  }
  const { data } = await api.get<{ success: boolean; data: PermissionDefinition[] }>(
    'platform-permissions/registry'
  );
  registryCache = data.data;
  return registryCache;
}

export async function fetchRolePermissions(roleName: string): Promise<Record<string, PlatformAccessLevel>> {
  const { data } = await api.get<{ success: boolean; data: Record<string, PlatformAccessLevel> }>(
    `platform-permissions/roles/${encodeURIComponent(roleName)}`
  );
  return data.data;
}

export async function saveRolePermissions(
  roleName: string,
  permissions: Record<string, PlatformAccessLevel>
): Promise<Record<string, PlatformAccessLevel>> {
  const { data } = await api.put<{ success: boolean; data: Record<string, PlatformAccessLevel> }>(
    `platform-permissions/roles/${encodeURIComponent(roleName)}`,
    { permissions }
  );
  return data.data;
}

export async function fetchUserOverrides(
  userId: number
): Promise<Record<string, PlatformAccessLevel | null>> {
  const { data } = await api.get<{ success: boolean; data: Record<string, PlatformAccessLevel | null> }>(
    `platform-permissions/users/${userId}/overrides`
  );
  return data.data;
}

export async function saveUserOverrides(
  userId: number,
  overrides: Record<string, PlatformAccessLevel | null>
): Promise<Record<string, PlatformAccessLevel | null>> {
  const { data } = await api.put<{ success: boolean; data: Record<string, PlatformAccessLevel | null> }>(
    `platform-permissions/users/${userId}/overrides`,
    { overrides }
  );
  return data.data;
}
